define('OutSystems/ClientRuntime/FeedbackMessageService',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.closeFeedbackMessage = exports.showFeedbackMessage = exports.setEnabled = exports.registerFeedbackMessageService = void 0;
    var feedbackMessageService;
    var onServiceRegistered;
    var isServiceEnabled = true;
    function registerFeedbackMessageService(service) {
        feedbackMessageService = service;
        if (onServiceRegistered) {
            onServiceRegistered();
            onServiceRegistered = null;
        }
    }
    exports.registerFeedbackMessageService = registerFeedbackMessageService;
    function setEnabled(enabled) {
        isServiceEnabled = enabled;
    }
    exports.setEnabled = setEnabled;
    function showFeedbackMessage(message, messageType, encodeHTML, extraCssClasses, closeOnClick, onClick) {
        if (encodeHTML === void 0) { encodeHTML = true; }
        if (extraCssClasses === void 0) { extraCssClasses = ""; }
        if (closeOnClick === void 0) { closeOnClick = true; }
        if (!isServiceEnabled) {
            return;
        }
        var show = function () {
            return feedbackMessageService.showMessage(message, messageType, encodeHTML, extraCssClasses, closeOnClick, onClick);
        };
        if (feedbackMessageService) {
            show();
        }
        else {
            onServiceRegistered = show;
        }
    }
    exports.showFeedbackMessage = showFeedbackMessage;
    function closeFeedbackMessage() {
        if (!isServiceEnabled) {
            return;
        }
        var close = function () { return feedbackMessageService.closeMessage(); };
        if (feedbackMessageService) {
            close();
        }
        else {
            onServiceRegistered = null;
        }
    }
    exports.closeFeedbackMessage = closeFeedbackMessage;
});
//# sourceMappingURL=FeedbackMessageService.js.map;
